import { IModalProps, Modal, Button } from '@/shared/ui';
import Copy from '@/assets/icons/thank-you/copy.svg';

type IProps = Omit<IModalProps, 'children'>;


const GreyHeadingAndSubheading = ({ heading, subText }: { heading: string; subText: string; }) => {
    return (
        <div className='flex flex-col items-start justify-center'>
            <span className='block text-[#9FA4A1] font-atkinsonBold text-12 sm:text-16 mb-[5px]'>
                {heading}
            </span>
            <span className='block font-atkinson text-14 sm:text-20'>
                {subText}
            </span>
        </div>
    )
}


export default (props: IProps) => {

    const handleCopy = () => {
        const prescriptionText =
            "AmeriPharma MedBox\n" +
            "132 S. Anita Dr. 2nd Floor\n" +
            "Orange, CA 92868\n" +
            "NPI: 1336170679\n" +
            "Phone: (800) 270-7091\n" +
            "Fax: (728) 928-2431";
        navigator.clipboard.writeText(prescriptionText);
    };

    return (
        <Modal
            {...props}
            className=""
            contentClassName="px-[20px] pb-[20px] pt-[30px] sm:px-[40px] sm:py-[40px]"
            dataTestId="ask-prescriber"
        >
            <div className='flex flex-col items-center justify-center gap-[20px]' data-testid="ask-prescriber-container">
                <span className='text-center flex flex-col gap-3'>
                    <span className='font-agrandir text-25 sm:text-30'>
                        Ask your prescriber to send your medications here
                    </span>
                    <span className='font-atkinson text-15 sm:text-20'>
                        By asking your prescriber to send your prescriptions directly to us, you can avoid the wait for your current pharmacy to process a transfer request.
                    </span>
                </span>

                <div className='w-full flex flex-col border-1 border-grey-500 rounded-xl shadow-askPresc'>
                    <div className='flex flex-col gap-2 px-[30px] py-[20px]'>
                        <div className='flex flex-col items-start justify-center'>
                            <span className='block text-[#9FA4A1] font-atkinsonBold text-12 sm:text-16 mb-[5px] '>
                                Electronic Prescription
                            </span>
                            <span className='block font-atkinson'>
                                AmeriPharma MedBox
                            </span>
                            <span className='block font-atkinson'>
                                132 S. Anita Dr. 2nd Floor Orange, CA <span className='hidden sm:inline'>92868</span>
                            </span>
                            <span className='block font-atkinson sm:hidden'>
                                92868
                            </span>
                            <span className='block font-atkinson'>
                                NPI: 1336170679
                            </span>

                        </div>
                        <GreyHeadingAndSubheading heading='Phone' subText='(800) 270-7091' />
                        <GreyHeadingAndSubheading heading='Fax' subText='(728) 928-2431' />
                    </div>
                    <div className="border-t-[1px] border-grey-500" />
                    <div data-testid="copy-information-container" onClick={handleCopy} className='flex items-center justify-center gap-2.5 cursor-pointer py-[20px] active:opacity-30 transition-opacity duration-600'>
                        <img src={Copy} alt="ic" />
                        <span data-testid="copy-information-text" className='text-primary font-atkinson text-16 sm:text-21'>Copy Information </span>
                    </div>
                </div>
                <Button className='w-full sm:mt-[7px]' showEndIcon onClick={props.onClose} testId="button-ask-prescriber-close">
                    Close
                </Button>
            </div>
        </Modal >
    );
}